import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appZipcode]'
})
export class ZipCodeDirective {
  @Input() allowFullZip = false;

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  protected onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter', 'Control', 'Meta', 'v', 'V', '-'];
    if ((event.key < '0' || event.key > '9') && !allowedKeys.includes(event.key) && !(event.ctrlKey || event.metaKey)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  protected onInput(event: Event) {
    let value = this.el.nativeElement.value;
    if (!value) return;

    this.formatAndSetValue(value);
  }

  private formatAndSetValue(value: string) {
    let formattedValue = value.replace(/[^0-9]/g, '');
    if (!this.allowFullZip) {
      formattedValue = formattedValue.slice(0, 5);
    } else {
      formattedValue = formattedValue.slice(0, 5) + (formattedValue.length > 5 ? '-' : '') + formattedValue.slice(5, 9);
    }

    if (formattedValue !== value) {
      this.control.valueAccessor.writeValue(formattedValue);
      this.control.control.setValue(formattedValue, { emitEvent: false });
    }
  }
}
